import EventEmitter from 'eventemitter3'

export const EventPipe = new EventEmitter<'REFRESH'>()
